<template>
  <div  style="height: 775px">
    <LabelHeader msg="缓存刷新"></LabelHeader>

    <div class="cache-content">
      <div class="title">
        <span class="span">字典缓存</span>
        <ul class="ul">
          <li>1.系统会缓存字典信息，从缓存总获取数据，大大提高程序响应时间。</li>
          <li>2.若通过系统修改字典信息，会自动刷新缓存；无需此操作。</li>
          <li style="color: #e11617">3.若直接通过数据库修改字典信息，则需要手动刷新缓存方可生效。</li>
        </ul>
        <el-button type="primary" size="mini" @click="refreshCache('dict')"><span>刷新</span></el-button>
      </div>
      <div class="title">
        <span class="span">菜单缓存</span>
        <ul class="ul">
          <li>1.系统会缓存菜单信息，从缓存总获取数据，大大提高程序响应时间。</li>
          <li>2.若通过系统修改菜单信息，会自动刷新缓存；无需此操作。</li>
          <li style="color: #e11617">3.若直接通过数据库修改菜单信息，则需要手动刷新缓存方可生效。</li>
        </ul>
        <el-button type="primary" size="mini" @click="refreshCache('menu')"><span>刷新</span></el-button>
      </div>
      <div class="title">
        <span class="span">配置缓存</span>
        <ul class="ul">
          <li>1.系统会缓存配置信息，从缓存总获取数据，大大提高程序响应时间。</li>
          <li>2.若通过系统修改配置信息，会自动刷新缓存；无需此操作。</li>
          <li style="color: #e11617">3.若直接通过数据库修改配置信息，则需要手动刷新缓存方可生效。</li>
        </ul>
        <el-button type="primary" size="mini" @click="refreshCache('config')"><span>刷新</span></el-button>
      </div>
      <div class="title">
        <span class="span">权限缓存</span>
        <ul class="ul">
          <li>1.系统会缓存权限信息，从缓存总获取数据，大大提高程序响应时间。</li>
          <li>2.若通过系统修改角色的授权信息，会自动刷新缓存；无需此操作。</li>
          <li style="color: #e11617">3.若直接通过数据库修改授权信息，则需要手动刷新缓存方可生效。</li>
        </ul>
        <el-button type="primary" size="mini" @click="refreshCache('permission')"><span>刷新</span></el-button>
      </div>
      <div class="title">
        <span class="span">模型缓存</span>
        <ul class="ul">
          <li>1.系统会缓存权限信息，从缓存总获取数据，大大提高程序响应时间。</li>
          <li>2.若通过系统修改角色的授权信息，会自动刷新缓存；无需此操作。</li>
          <li style="color: #e11617">3.若直接通过数据库修改授权信息，则需要手动刷新缓存方可生效。</li>
        </ul>
        <el-button type="primary" size="mini" @click="management()"><span>刷新</span></el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import LabelHeader from "../../components/LabelHeader";
export default {
  data() {
    return {};
  },
  components:{
    LabelHeader
  },
  methods: {
    refreshCache(value) {
      let par = {
        type: value
      };
      //('正在刷新缓存，请稍后');
      httpKit.post('/lims/cache/flush/' + value + '.json', par).then(res => {
        if (res.data.code === '200') {
          let userId = { userId: storageKit.get(jsCtx.localConstant.userId) };
          httpKit.post($api_eap.menu.user, userId).then(row => {
            if (row.data.code === '200') {
              storageKit.setJson(jsCtx.localConstant.menu, row.data.data);
              //.close();
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(row.data.msg);
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    management() {
      //('正在刷新缓存，请稍后');
      httpKit.post($api_eap.category.clear).then(res => {
        if (res.data.code === '200') {
          //.close();
          this.$message.success('刷新成功');
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
  .el-button {
    width: 200px;
  }
  .span {
    font-size: 16px;
    font-weight: bold;
  }
  .cache-content{
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .title {
    background-color: #f2f2f2;
    width: calc(50% - 6px);
    margin: 8px 0;
    padding: 10px;
  }
  .ul {
    margin: 20px 0;
    li{
      list-style: none;
    }
  }
</style>
